import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import DirectionsIcon from '@material-ui/icons/Directions';
import IconButton from '@material-ui/core/IconButton';
import Grow from '@material-ui//core/Grow';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    promotionContainer: {
        width: '97%',
        maxWidth: 700,
        margin: '0 auto',
        marginTop: 13,
        position: 'relative',
        // overflow: 'hidden',
        height: 'auto',
        background: 'rgba(255, 255, 255, 0.85)',
        'border-bottom-right-radius': 7,
        'border-bottom-left-radius': 7,
        'border-top-right-radius': 7,
        'border-top-left-radius': 7,
        // 'box-shadow': '0px -1px 2px #ccc',
        // border: '1px solid #ff7429',
    },
    promotionContainerImageSubcat: {
        width: '100% !important',
        maxWidth: 'none !important',
        borderRadius: '0 !important',
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
    },

    promotionTitleHorizontal: {
        // background: '#ff7429',
        // background: 'linear-gradient(90deg, rgb(254,105,2) 0%, rgb(203,65,2) 78%)',
        background: 'rgb(255, 113, 47)',
        color: 'white',
        fontSize: 14,
        fontWeight: 'bold',
        textAlign: 'center',
        'border-top-right-radius': 7,
        'border-top-left-radius': 7,
        // 'border-bottom-right-radius': 7,
        // 'border-bottom-left-radius': 7,
    },

    promotionTitle: {
        letterSpacing: -1,
        padding: '1px 8px',
        textAlign: 'center',
        color: 'white',
        'border-top-left-radius': 7,
        'border-bottom-left-radius': 7,
        fontSize: 12,
        zIndex: 12,
    },

    promotionItem: {
        fontSize: 14,
        '@media screen and (max-width: 350px)': {
            fontSize: 13,
        },
        padding: '6px 0',
        width: 'calc(100% - 40px)'
    },

    promotionIcon: {
        color: '#fd6a00',
    },


    // Promotions with navigation
    promotionsWithNavigationContainer: {
        borderRadius: 6,
        backgroundColor: '#e6e6e6',
        // display: 'grid',
        // 'grid-template-columns': 'calc(100% - 100px) 100px',
        display: 'flex',
        'justify-content': 'center',
    },
    promotionsNavigationLeftSide: {
        placeSelf: 'center',
        '@media screen and (max-width: 350px)': {
            fontSize: '16px !important'
        },
        '& *': {
            '@media screen and (max-width: 350px)': {
                fontSize: '16px !important'
            },
        }
    },
    promotionsNavigationRightSide: {
        // width: '100%',
        placeSelf: 'center',
        verticalAlign: 'bottom',
        // borderLeft: '1px solid #ccc',
        textAlign: 'center',
    },
    promotionsNavigationLink: {
        display: 'grid',
        'grid-template-rows': '50% 50%',
        textDecoration: 'none',
        padding: '0 10px',
        '@media screen and (max-width: 350px)': {
            padding: 0,
        }
    },
    promotionsNavigationIcon: {
        fontSize: 30,
        color: '#0064ac',
    },
    promotionsNavigationText: {
        textAlign: 'center',
        fontSize: 14,
        color: '#0064ac',
        paddingTop: 5,
    }
}));


const Promotions = (props) => {
    const classes = useStyles();
    const { settings, translations } = props;

    let promotions = [];
    let promotionsLength = 0;
    if (settings.promotions_html && settings.promotions_html.value) {
        const promotions_with_navigation = settings.promotions_with_navigation && settings.promotions_with_navigation.value && settings.promotions_with_navigation.value == '1';

        promotions =
            <div className={promotions_with_navigation ? classes.promotionsWithNavigationContainer : {}}>
                <div className={classes.promotionsNavigationLeftSide} dangerouslySetInnerHTML={{
                    __html: settings.promotions_html.value
                }}></div>
                {promotions_with_navigation ?
                    <div className={classes.promotionsNavigationRightSide}>
                        <a target="_blank" rel="noopener noreferrer" href={'https://www.google.com/maps/dir/?api=1&destination=' + (settings.place_address ? settings.place_address.value : '')} className={classes.promotionsNavigationLink}>
                            <IconButton aria-label="navigate" color="primary" >
                                <DirectionsIcon className={classes.promotionsNavigationIcon} />
                            </IconButton>
                            <div className={classes.promotionsNavigationText}>{translations && translations.common && translations.common.navigate_me ? translations.common.navigate_me : ''}</div>
                        </a>
                    </div>
                    :
                    null
                }
            </div>

        promotionsLength = 2;
    } else if (settings.promotions_text && settings.promotions_text.value) {
        promotions = JSON.parse(settings.promotions_text.value);
        promotions = Object.values(promotions).map((p, k) =>
            <ListItem button className={classes.promotionItem} key={k}>
                <ArrowRightIcon className={classes.promotionIcon} /> {p}
            </ListItem>
        )
        promotionsLength = Object.keys(promotions).length;
    }

    const subcategories_design = settings.subcategories_design && settings.subcategories_design.value ? settings.subcategories_design.value : false;

    let promotionContainer = null;
    if (promotionsLength > 0) {
        promotionContainer = (
            <Grow in={true} timeout={{ enter: 450, exit: 450 }}>
                <div className={subcategories_design == '1' ? clsx(classes.promotionContainer, 'box', classes.promotionContainerImageSubcat) : clsx(classes.promotionContainer, 'box')}>
                    <div className={promotionsLength == 1 ? classes.promotionTitleHorizontal : (subcategories_design == '1' ? clsx(classes.promotionTitle, 'ribbon', 'ribbon-image-subcat') : clsx(classes.promotionTitle, 'ribbon'))} style={settings.promotions_title && settings.promotions_title.value ? {} : { display: 'none' }}>
                        <span>
                            {settings.promotions_title && settings.promotions_title.value ? settings.promotions_title.value : ''}
                        </span>
                    </div>
                    <div className={classes.promotionContent}>
                        {promotions}
                    </div>
                </div>
            </Grow>
        )
    }

    return promotionContainer;

}

export default Promotions;